import {useMutation} from 'react-query';
import {setGradeAnswer} from 'services/grade';

const useSetGradeAnswers = (
  setIsOpenGrade: React.Dispatch<React.SetStateAction<boolean>>,
  setIsOpenGradeAnswer: React.Dispatch<React.SetStateAction<boolean>>,
  setGrade: React.Dispatch<React.SetStateAction<number>>,
) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISetGradePayload) => {
      return setGradeAnswer(payload);
    },
    onSuccess: (response, variables) => {
      setGrade(response?.grade);
      setIsOpenGrade(false);
      setIsOpenGradeAnswer(true);
    },
  });

  return {isLoading, gradeMutate: mutate};
};

export default useSetGradeAnswers;
